import { Box } from '@mui/material';

import Page from '../../components/Page/index.ts';
import StaticPageLayout from '../../components/StaticPageLayout/index.ts';
import { LANG } from '../../services/Config.js';

export default function TermsMinScoopr() {
  const { appStrings } = LANG;
  return (
    <Page title={appStrings.PAGES.TERMS_MIN_SCOOPR}>
      <StaticPageLayout
        title="Generelle vilkår og betingelser for bruk av Scoopr"
        breadcrumbsItems={[
          {
            text: 'Hjem',
            url: '/',
          },
          {
            text: 'Brukervilkår av Scoopr',
            url: null,
          },
        ]}
        subtitle="Vilkårene ble sist oppdatert: 26.08.2026"
      >
        <Box
          sx={(theme) => ({
            '& h2': {
              marginBottom: theme.spacing(2),
              marginTop: theme.spacing(6),
            },
            '& h3': {
              marginBottom: theme.spacing(1),
              marginTop: theme.spacing(3),
            },
          })}
        >
          <h2>OM TJENESTEN</h2>
          <p>
            Scoopr («Scoopr» eller «Tjenesten») er en applikasjon tilgjengelig på scoopr.no.
            Tjenesten kan benyttes av privatpersoner som er over 18 år og har BankID, heretter
            omtalt som «Bruker», «du» eller «deg».
          </p>
          <p>
            Dette er brukervilkårene for Tjenesten («Brukervilkårene»). Brukervilkårene regulerer
            din adgang til og bruk av Tjenesten. Alle referanser til «vi» og «oss» i det følgende
            viser til Scoopr AS organisasjonsnummer 952 660 225, med konsesjon som låne- og
            kredittformidler underlagt tilsyn av Finanstilsynet, heretter omtalt som «Scoopr».
          </p>
          <p>
            <b>
              Ved å trykke «Fortsett med BankID/Vipps» aksepterer du Brukervilkårene, identifiserer
              deg med BankID og oppretter en brukerprofil.
            </b>
          </p>

          <h2>1. Hva er Scoopr?</h2>

          <h3>1.1 Oversikt og innsikt</h3>
          <p>
            Når du oppretter en brukerkonto, får du tilgang til funksjonalitet som gir deg oversikt
            over din økonomiske situasjon, dette kan være:
          </p>
          <ul className="list-disc pl-6">
            <li>
              Usikret gjeld, kredittscore og kredittopplysninger (betalingsanmerkninger, roller,
              næringsinteresser, inntekt, skatt, formue, eiendomsinformasjon m.m.).
            </li>
            <li>
              Beregnet sparepotensial basert på din gjeldsstruktur og tilgjengelige lånetilbud og
              kredittkorttilbud.
            </li>
          </ul>
          <p>
            Opplysningene hentes fra tredjeparter, bl.a. Gjeldsregisteret AS og Creditsafe AS.
            Scoopr utøver innsynsrett på dine vegne. Vi kan ikke garantere fullstendig riktighet
            eller oppdatering av dataene, da de kommer fra eksterne kilder.
          </p>

          <h3>1.2 Låne- og kredittkortformidling</h3>
          <p>
            Som låne- og kredittformidler tilbyr Scoopr sammenligning av lån og kredittkort fra
            banker/kortutstedere Scoopr samarbeider med. Vi innhenter tilbud fra flere
            banker/utstedere og presenterer dem for deg. En eventuell låne- eller kredittkortavtale
            inngås direkte mellom deg og banken/utstederen. Vilkårene for selve kreditt- eller
            kortavtalen, herunder angrerett, effektiv rente og øvrige lovpålagte opplysninger,
            følger av avtalen du inngår direkte med banken/utstederen, og ikke av disse
            Brukervilkårene.
          </p>

          <h3>1.3 Monitorering og varsler</h3>
          <p>
            Scoopr kan overvåke datapunkter som kredittscore, gjeld og eiendomsverdier, og varsle
            deg om endringer.
          </p>

          <h3>1.4 Tilpassede anbefalinger basert på dine data</h3>
          <p>
            Basert på endringer i dine data og din generelle økonomiske situasjon, kan Scoopr gi deg
            tilpassede anbefalinger om refinansiering, forbrukslån, boliglån, kredittkort og andre
            tjenester. Disse anbefalingene er ment å hjelpe deg med å ta bedre beslutninger om din
            økonomi og utnytte tilgjengelige muligheter.
          </p>
          <p>
            Vær oppmerksom på at monitoreringstjenesten, varslingene og anbefalingene er basert på
            data hentet fra tredjeparter, og vi kan ikke garantere fullstendig nøyaktighet eller
            aktualitet. Vi anbefaler deg å verifisere informasjonen før du tar viktige økonomiske
            beslutninger. Du kan når som helst endre dine anbefalingspreferanser inne i Min Scoopr.
          </p>

          <p>
            <b>Nye funksjoner</b>
          </p>
          <p>
            Når vi lanserer nye funksjoner og eller tjenester kan vi sende deg varsel om disse.
            Tjenestene/funksjonene kan være levert av 3.part.
          </p>

          <h3>1.5 Kostnader</h3>
          <p>
            Opprettelse av brukerkonto og bruk av Scoopr er gratis for deg som Bruker. Dersom du
            inngår låne- eller kredittkortavtale, betaler banken/utstederen Scoopr provisjon.
          </p>

          <h3>1.6 Markedsføring («Scoopr-fordel») – varsler om konkurranser og lånetilbud</h3>
          <p>
            Ved å krysse av for «Scoopr-fordel» samtykker du til at Scoopr kan kontakte deg med
            markedsføring om Scooprs konkurranser, lånetilbud og produktoppdateringer. Kontakt kan
            skje via e-post, SMS, telefon og/eller push-varsler i appen.
          </p>
          <p>
            Samtykket er frivillig og ikke en forutsetning for å bruke Tjenesten. Du kan når som
            helst trekke samtykket i Min Scoopr, via avmeldingslenke i meldingen, eller ved å gi
            beskjed ved telefonkontakt. Vi stopper da videre henvendelser uten ugrunnet opphold.
          </p>
          <p>
            Vi deler ikke dine kontaktopplysninger med banker for deres egen markedsføring uten et
            separat, uttrykkelig samtykke. Henvendelser kan tilpasses basert på de opplysninger du
            har gitt og data vi behandler om deg, i tråd med vår personvernerklæring og gjeldende
            regelverk, herunder markedsføringsloven.
          </p>

          <h2>2. Opprettelse og bruk</h2>

          <h3>2.1 Registrering</h3>
          <p>
            For å bruke Scoopr må du identifisere deg med BankID. Du er ansvarlig for sikkerheten
            til din konto, og forplikter deg til å varsle Scoopr dersom du har mistanke om misbruk.
          </p>

          <h3>2.2 Varighet og oppsigelse</h3>
          <p>
            Du kan når som helst avslutte din brukerkonto i Min Scoopr. Scoopr kan avslutte eller
            suspendere kontoen dersom du bryter vilkårene.
          </p>

          <h3>2.3 Bruksrett</h3>
          <p>
            Ved å akseptere Brukervilkårene gis du en ikke-eksklusiv bruksrett til Scoopr. Du kan
            ikke modifisere, kopiere eller utnytte Tjenesten utover det som er uttrykkelig tillatt.
            Automatisert tilgang eller misbruk er ikke tillatt.
          </p>

          <h3>2.4 Brukerdata</h3>
          <p>
            Du eier dine egne data. Scoopr har rett til å benytte og dele dine data i den grad det
            er nødvendig for å levere Tjenesten. Scoopr kan benytte anonymiserte og aggregerte data
            til analyse, forbedring og statistikk.
          </p>

          <h3>2.5 Søkerdata ved lån og kredittkort</h3>
          <p>
            Dersom du søker lån eller kredittkort gjennom Scoopr, samtykker du til at vi innhenter
            og deler dine opplysninger med bankene/utstederne vi samarbeider med. Dersom du inngår
            låne- eller kredittkortavtale, lagres dine søknadsdata i inntil tre (3) år fra
            tidspunktet lånet er registrert utbetalt, eller kreditten er registrert etablert, i tråd
            med lovpålagte krav.
          </p>

          <h2>3. Personvern og samtykke</h2>

          <p>
            Scoopr behandler personopplysninger i samsvar med gjeldende lovgivning og vår
            personvernerklæring. Dette omfatter blant annet:
          </p>
          <ul className="list-disc pl-6">
            <li>Identitets- og kontaktopplysninger.</li>
            <li>Kredittopplysninger og finansielle data.</li>
            <li>Søkerdata og samtykker.</li>
          </ul>
          <p>
            Du kan når som helst trekke tilbake ditt samtykke til at Scoopr behandler opplysninger
            til markedsføringsformål («Scoopr-fordel»). Når samtykket trekkes tilbake, vil vi stanse
            markedsføring og slette opplysninger i tråd med gjeldende lovgivning.
          </p>
          <p>
            Scoopr bruker også informasjonskapsler (cookies). En fullstendig oversikt finnes i vår
            cookie-erklæring.
          </p>

          <h2>4. Immaterielle rettigheter</h2>

          <p>
            Scoopr eier alle rettigheter til konsept, design, varemerker, programvare, know-how,
            forretningshemmeligheter og øvrige immaterielle rettigheter knyttet til Tjenesten.
          </p>

          <h2>5. Ansvar</h2>

          <h3>5.1 Scoopr sitt ansvar</h3>
          <p>
            Scoopr opptrer som låne- og kredittformidler og ikke som långiver eller kortutsteder.
            Scoopr har ingen innflytelse på bankenes kredittvurderinger eller beslutninger. Scoopr
            kan ikke holdes ansvarlig for tap som følge av informasjon fra tredjeparter eller
            bankenes/utstedernes beslutninger.
          </p>

          <h3>5.2 Ansvarsbegrensning</h3>
          <p>
            Erstatningsansvar kan kun kreves dersom Scoopr har opptrådt grovt uaktsomt eller
            forsettlig. Erstatning begrenses til direkte økonomisk tap. Indirekte tap, inkludert
            tapt fortjeneste eller datatap, dekkes ikke.
          </p>

          <h2>6. Endringer i Tjenesten og Vilkårene</h2>

          <p>
            Scoopr kan når som helst endre eller trekke tilbake Tjenesten. Vesentlige endringer i
            Brukervilkårene vil bli varslet. Dersom du fortsetter å bruke Tjenesten etter endringer,
            anses du å ha akseptert de nye vilkårene.
          </p>

          <h2>7. Overdragelse</h2>

          <p>
            Scoopr kan overdra sine rettigheter og plikter etter disse Brukervilkårene til andre
            selskaper, for eksempel i forbindelse med restrukturering, fusjon eller salg. Bruker kan
            ikke overdra sine rettigheter eller plikter.
          </p>

          <h2>8. Lovvalg og tvister</h2>

          <p>
            Brukervilkårene reguleres av norsk rett. Tvister skal søkes løst gjennom forhandling.
            Dersom dette ikke lykkes, skal tvisten avgjøres av Oslo tingrett. Som forbruker har du
            rett til å klage til Forbrukerrådet, se{' '}
            <a href="https://www.forbrukerradet.no/klageguide/">
              https://www.forbrukerradet.no/klageguide/
            </a>
            .
          </p>

          <h2>9. Kontaktinformasjon</h2>
          <p>Dersom du har spørsmål kan du kontakte oss på:</p>
          <p>
            <b>Scoopr AS</b>
          </p>
          <p className="ml-6">
            Org.nr. 952 660 225
            <br />
            Karenslyst Allé 2, 0278 Oslo
          </p>
          <p>
            E-post: <a href="mailto:post@scoopr.no">post@scoopr.no</a>
          </p>
        </Box>
      </StaticPageLayout>
    </Page>
  );
}
